import { InputType } from "@app/enum/input-type";
import { QuestionBase } from "../question-base";

export class DropDownquestion extends QuestionBase<string> {
  override type = InputType.DROPDOWN;
}